<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbMasterDerivatives',
  components: {},
}
</script>
